module.exports = __webpack_public_path__ + "img/wz-8-4-3.704d2e2c.jpg";